var DbDoc, MINI_DS_DOC_PREFIX, miniDSDocShape;

DbDoc = require('lib/db_docs/db_doc');

miniDSDocShape = require('lib/db_docs/doc_shapes/mini_ds_doc_shape');

MINI_DS_DOC_PREFIX = require('lib/doc_prefixes').miniDsDoc;

module.exports = DbDoc(miniDSDocShape, {
  dbSetup: {
    idPrefix: MINI_DS_DOC_PREFIX
  }
});
